import React from "react";
import SupportStore from "../components/SupportStore";
import SaharaCampaign from "../components/SaharaCampaign";
import ImpactStories from "../components/ImpactStories";
import DonationForm from "../components/DonationForm";
import MissionTicker from "../components/MissionTicker";
import SupportWallFooter from "../components/SupportWallFooter";

const Fund = () => {
  return (
    <div className="career-page">
      <SupportStore />
      <SaharaCampaign />
      <ImpactStories />
      <DonationForm />
      <MissionTicker />
      <SupportWallFooter />
      {}
    </div>
  );
};

export default Fund;
